<template>
  <base-popover
    v-slot="props"
    :arrow-shift="-6"
    class="flex"
    data-test-id="vf-tooltip"
    :delay
    :flip
    :offset="{ mainAxis: 10, alignmentAxis: -20 }"
    :placement
    :teleport
  >
    <base-button
      :aria-labelledby="id"
      :class="classTrigger"
      @blur="props.close"
      @click="$emit('click')"
      @focus="props.open"
      @keydown.esc="props.close"
      @mouseenter="props.open"
      @mouseleave="props.close"
    >
      <span class="sr-only">{{ $t.moreInfoAbout }}</span>
      <!-- @slot Slot for tooltip trigger -->
      <slot name="trigger" v-bind="props" />
    </base-button>
    <base-popover-content
      :id
      class="z-overlay b b-grey-70 bg-white px-4 py-6 text-sm shadow-xs transition"
      data-test-id="vf-tooltip-content"
      enter-active-class="transform ease-out"
      enter-from-class="op-0 scale-95"
      enter-to-class="translate-y-0 scale-100"
      leave-active-class="transform ease-in"
      leave-from-class="translate-y-0 scale-100"
      leave-to-class="op-0 scale-95"
      role="tooltip"
      style="max-width: 15rem"
    >
      <!-- @slot Slot for toggletip content -->
      <slot v-bind="props" />
      <base-popover-arrow
        class="absolute transform b-grey-70 bg-white"
        :class="props.side === 'top' ? 'b-b b-r' : 'b-t b-l'"
        style="width: 0.625rem; height: 0.625rem; rotate: 45deg"
      />
    </base-popover-content>
  </base-popover>
</template>

<script lang="ts" setup>
import type { CSSClass } from '#types/common'

const { flip = true, teleport = true } = defineProps<{
  /**
   * The position of the Tooltip.
   * By default `bottom`.
   */
  placement?: 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end'
  /**
   * If tooltip should change the placement of the floating element to the opposite
   * on scroll/resize
   */
  flip?: boolean
  /**
   * Show/Hide delay, or object in ms.
   */
  delay?: number | { show?: number, hide?: number }
  /**
   * Where the Popover should be mounted to. By default it will be mounted to the body.
   */
  teleport?: boolean | string | HTMLElement
  /**
   * Classes to be applied to trigger container.
   */
  classTrigger?: CSSClass
}>()

defineEmits<{
  click: []
}>()

const id = useId()
</script>
